// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"extract":true,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=data-v-196a7a1c&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/PrivacyPolicy.vue
// module id = 274
// module chunks = 2